import { createSlice } from "@reduxjs/toolkit";

const BussinessListSlice = createSlice({
  name: "bussinessList",
  initialState: {
    List: [
      {
        legal: {},
        real: {},
      },
    ],
  },

  reducers: {
    callBussinessList: (state, action) => {
      // ////console.log("payload" , action.payload.listItem.real.items);
      state.List[0].legal = [...action.payload.listItem.legal.items];
      state.List[0].real = [...action.payload.listItem.real.items];

      // ////console.log("aaaaaaaaaaaaa");
    },
  },
});

export const { callBussinessList } = BussinessListSlice.actions;
export default BussinessListSlice.reducer;
